export const PLACE_CONFIG_READ_SLUG = 'place.config.read';
export const PLACE_CONFIG_WRITE_SLUG = 'place.config.write';

export function canViewPlaceConfig(roles: readonly string[]): boolean {
  return roles.includes(PLACE_CONFIG_READ_SLUG) || roles.includes(PLACE_CONFIG_WRITE_SLUG);
}

export function canMutatePlaceConfig(roles: readonly string[]): boolean {
  return roles.includes(PLACE_CONFIG_WRITE_SLUG);
}
